import { type ChangeEvent } from 'react'

import { TextArea } from '@/shared'

import style from './AddFields.module.scss'

interface IProps {
    setShowAdd: (showAdd: boolean) => void
    title: string
    setTitle: (title: string) => void
    description: string
    setDescription: (description: string) => void
}

export const AddFields = (props: IProps) => {
    const { setShowAdd, title, setTitle, description, setDescription } = props

    const onChangeTitle = (e: ChangeEvent<HTMLInputElement>) => setTitle(e.target.value)
    const onChangeDescriptions = (e: ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)

    const onGoBack = () => {
        setTitle('')
        setDescription('')
        setShowAdd(false)
    }

    return (
        <div className={style.container}>
            <div className={style.goBack}>
                <span onClick={onGoBack}>вернуться назад</span>
            </div>
            <div className={style.fields}>
                <input value={title} onChange={onChangeTitle} placeholder='Укажите заголовок правила' />
                <TextArea value={description} onChange={onChangeDescriptions} placeholder='Укажите описание правила' />
            </div>
        </div>
    )
}
